<template>
  <div v-show="visible">
    <el-row :gutter="20" v-if="showModel && showModel == 2 && need == 1" v-loading="loading">
      <el-col :span="7" :offset="0" v-for="(item, key) in areaList.province_list" :key="key">
        <div style="width: 100%; margin: 5px" @click="confirm1(item.Province, item.Provinceid)">
          <el-tag :type="(defaultValue && defaultValue == key) ||
            (defaultArea && defaultArea == item.Province)
            ? 'danger'
            : 'info'
            " size="mini" effect="plain">{{ item.Province }}</el-tag>
        </div>
      </el-col>
      <!-- <el-col :span="6" :offset="0"></el-col>
      <el-col :span="6" :offset="0"></el-col>
      <el-col :span="6" :offset="0"></el-col>-->
    </el-row>

    <van-area :area-list="allList" @change="change" @confirm="confirm" :confirm-button-text="!selectedArray || selectedArray.length < need ? '-' : '确定'
      " cancel-button-text :visible-item-count="visibleCount" :value="defaultValue" :columns-num="columnsNum"
      :columns-placeholder="['选择省份', '选择市', '选择区域']" v-else>
      <!-- <template #Title></template> -->

      <template #columns-top>
        <div style="width: 100%">
          {{ selectedAddr ? selectedAddr : message ? message : "请先选择呢" }}
          {{ !allList.province_list ? "省份" : "" }}
          {{ !allList.city_list ? "市" : "" }}
          {{ !allList.county_list ? "区" : "" }}
        </div>
      </template>

      <template #columns-bottom>
        <!-- <div class="_columns-bottom">
          <el-button class="_btn" @click="cancel">取消</el-button>
          <el-button
            type="primary"
            class="_btn"
            @click="confirm"
            :disabled="!selectedArray||selectedArray.length<need"
          >确定选择</el-button>
        </div>-->
        <!-- <div style="width:100%;height:80px" v-if="selectedAddr">当前:{{selectedAddr}}</div> -->
      </template>
    </van-area>
  </div>
</template>

<script>
import { GetProvinceApi } from "@/assets/request/api.js";
import allList2 from "@/area/index.js";
import { areaList as allList } from '@vant/area-data';
export default {
  props: {
    defaultValue: {},
    defaultArea: { type: String, default: "" },
    showModel: {
      type: Number,
      default: 1,
    },
    need: {
      type: Number,
      default: 3,
    },
    columnsNum: {
      type: Number,
      default: 3,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    visibleCount: {
      type: Number,
      default: 5,
    },
    showAll: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      allList: {
        province_list: {},
        city_list: {},
        county_list: {}
      },
      areaList: {
        province_list: [],
      },
      message: "",
      selectedAddr: "",
      selectedArray: [],
      loading: false,
    };
  },
  created() {
    // 判断空对象
    if (allList && allList.province_list) {
      this.allList = allList
      return;
    } else {
      // 提示
      this.message = "地区数据加载失败"
      console.log(allList, allList2);
      if (allList2 && allList2.province_list) {
        this.message = ""
        this.allList = allList2
      }
    }
  },
  mounted() {

    if (!this.need) {
      this.need = 3;
    }
    if (this.showModel && this.showModel == 2 && this.need == 1) {
      this.GetProvince();
    }
  },
  methods: {
    GetProvince() {
      let that = this;
      this.loading = true;
      let params = {
        Page: 1,
        Limit: 100,
      };
      GetProvinceApi(params).then((res) => {
        if (res.code === 0) {
          that.loading = false;
          console.log(res.data.List);
          that.areaList.province_list = res.data.List;

          // if (this.showAll) {
          //   that.areaList.province_list["0"] = "全国";
          // }
        }
      });
    },

    checkdata() {
      var dataarr = this.selectedArray;
      for (var i = 0; i < this.need; i++) {
        if (!dataarr[i] || !dataarr[i].code || !dataarr[i].name) {
          this.$toast(i == 0 ? "请选择省" : i == 1 ? "请选择市" : "请选择区县");
          return false;
        }
      }
      var arr = [];
      for (var j = 0; j < dataarr.length; j++) {
        if (!dataarr[j] || !dataarr[j].code || !dataarr[j].name) {
        } else {
          arr.push(dataarr[j]);
        }
      }
      console.log(arr);
      this.selectedArray = arr;
      return arr;
    },

    confirm() {
      if (this.checkdata()) {
        this.$emit("confirm", this.selectedArray);
      }
    },
    confirm1(item, key) {
      console.log("key=" + key + ",item=" + item);
      this.selectedArray = [{ code: key, name: item }];
      this.$emit("confirm", this.selectedArray);
    },
    cancel() {
      this.$emit("cancel");
      this.$emit("update:visible", false);
    },
    // 拿到选择过后的省和市
    change(picker, values, index) {
      console.log(values);
      var arr = [];
      for (var j = 0; j < values.length; j++) {
        if (!values[j] || !values[j].code || !values[j].name) {
        } else {
          arr.push(values[j]);
        }
      }
      console.log(arr);
      this.selectedArray = arr;
      this.selectedAddr =
        (values[0] && values[0].name ? values[0].name : "") +
        (values[1] && values[1].name ? "-" + values[1].name : "") +
        (values[2] && values[2].name ? "-" + values[2].name : "");
      console.log(selectedAddr);
    },
  },
};
</script>

<style scoped>
._columns-bottom {
  width: 100%;
  display: flex;
  padding: 5px;
}

._columns-bottom ._btn {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/area.vue